import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 md:mb-8">
      <div>
        {eyebrow && (
          <p className="mb-1.5 font-label text-xs uppercase tracking-[0.25em] text-primary-400">{eyebrow}</p>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm text-foreground-400">{description}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group inline-flex items-center gap-1 whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-primary-400"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}